export const Langs = []



// WEBPACK FOOTER //
// ./src/customization/SteelOApp/langs.js